import { Checkbox, Flex } from '@aloft/toolkit-sui';
import { ColumnDef as ReactTableColumnDef } from '@tanstack/react-table';

import { IS_SELECTED_COLUMN_ID } from './constants.js';
import { TPTableSelectRow } from './types.js';

export function makeMultiSelectIsSelectedColumn<T>(
  shouldPinFirstRow: boolean,
  onRowSelect: TPTableSelectRow<T> | undefined,
  __dangerOverrideInternalSelectionState?: boolean,
): ReactTableColumnDef<T> {
  return {
    id: IS_SELECTED_COLUMN_ID,
    size: 32,
    cell: (cellCtx) => {
      const { row } = cellCtx;
      const isSelected = row.getIsSelected();
      const isDisabled = !__dangerOverrideInternalSelectionState && !row.getCanSelect();

      const handleClick = (event: any) => {
        event.stopPropagation();
        if (isDisabled) return;

        const nextState = !isSelected;
        onRowSelect?.(row.original, nextState);

        const toggleSelected = row.getToggleSelectedHandler();
        toggleSelected(event);
      };

      return (
        <Flex
          height="100%"
          alignItems="center"
          justifyContent="center"
          onClick={(event) => {
            // lets us provide an `onClick` handler to the row and checkbox
            event.stopPropagation();
          }}
        >
          <Checkbox onChange={handleClick} isChecked={isSelected} isDisabled={isDisabled} />
        </Flex>
      );
    },
  };
}
